import script from "./BackTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackTop.vue?vue&type=script&lang=ts&setup=true"

import "./BackTop.vue?vue&type=style&index=0&id=a7673d0e&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7673d0e"]])

export default __exports__